/**
 * Один способ рассказать человеку о позициях, оставшихся без карточки.
 *
 * Приёмка вызывается с четырёх экранов (конвейер, каталог, очередь тематики,
 * карточка макета) и пропускает непокрытые категории молча. Чтобы формулировка
 * и тон не разъехались по местам вызова, сообщение собирается здесь.
 */

import { useCallback } from 'react'
import { useToastStore } from '../../stores/toastStore'
import { coverageNotice, type FunnelCoverage } from './funnelCoverage'

export function useCoverageNotice() {
  const showToast = useToastStore((s) => s.showToast)

  return useCallback(
    (
      coverage: FunnelCoverage | null,
      options: { designCode?: string; designs?: number } = {},
    ) => {
      const notice = coverageNotice(coverage, options)
      if (!notice) return
      showToast({
        type: notice.tone,
        title: notice.title,
        message: notice.message,
        // Список категорий читают дольше обычного «Готово»
        duration: 12000,
      })
    },
    [showToast],
  )
}
